import { createWorker } from '../worker-api/create-worker';

createWorker(async (data: any, options?: Record<string, any>) => {
  return data;
});
